import { IDoanhNghiepThucTapActionTypes } from "../../action-types/category/IDoanhNghiepThucTapActions";
import { IDoanhNghiepThucTapReducer } from "../../reducer-model/category/IDoanhNghiepThucTapReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDoanhNghiepThucTapReducer = {
    status: eReducerStatusBase.is_not_initialization,
    doanhNghiepThucTaps: [],
}

export const DoanhNghiepThucTapReducer = (state = iniState, action: IDoanhNghiepThucTapActionTypes): IDoanhNghiepThucTapReducer => {
    switch (action.type) {
        case "DOANH_NGHIEP_THUC_TAP_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOANH_NGHIEP_THUC_TAP_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                doanhNghiepThucTaps: action.payload,
            };
        case "DOANH_NGHIEP_THUC_TAP_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOANH_NGHIEP_THUC_TAP_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                doanhNghiepThucTapEditing: action.payload,
            };
        case "DOANH_NGHIEP_THUC_TAP_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "DOANH_NGHIEP_THUC_TAP_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "DOANH_NGHIEP_THUC_TAP_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "DOANH_NGHIEP_THUC_TAP_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOANH_NGHIEP_THUC_TAP_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DOANH_NGHIEP_THUC_TAP_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOANH_NGHIEP_THUC_TAP_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}